var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.9467 5.45337H7.79341H4.05341C3.41341 5.45337 3.09341 6.2267 3.54674 6.68004L7.00008 10.1334C7.55341 10.6867 8.45341 10.6867 9.00674 10.1334L10.3201 8.82003L12.4601 6.68004C12.9067 6.2267 12.5867 5.45337 11.9467 5.45337Z"}));
}

ArrowDown.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 16 16","fill":"currentColor"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
